import PropTypes from 'prop-types'
import React from 'react'
import { Dropdown } from '@plurall/elo'
import styles from './QuestionFilters.module.scss'

const QuestionFilters = ({
  text,
  tags,
  filters,
  handleFiltersChange,
  handleChange,
  fetchQuestions,
  clearFiltersSelected,
  selected,
}) => (
  <>
    <div className={styles.filters}>
      {filters.length !== 0 &&
        filters.map(filter => (
          <Dropdown
            key={filter.name}
            items={filter.values}
            name={filter.name}
            disabled={filter.values.length === 0}
            multiselect
            placeholder='Selecione'
            selected={selected[filter.paramName] === undefined ? [] : selected[filter.paramName]}
            onChange={value => handleFiltersChange(value, filter.paramName)}
          />
        ))}
    </div>
    <div className={styles['filters-input']}>
      <div className={styles['filter-input']}>
        <label className={styles.name}>Busca textual</label>
        <input
          type='text'
          className={styles['input-form']}
          name='text'
          value={text}
          onChange={handleChange}
        />
      </div>
      <div className={styles['filter-input']}>
        <label className={styles.name}>Tags</label>
        <input
          type='text'
          className={styles['input-form']}
          name='tags'
          value={tags}
          onChange={handleChange}
          placeholder='Separe tags diferentes com , (vírgula).'
        />
      </div>
    </div>
    <div className={styles['filters-input']}>
      <input
        className={styles.button}
        type='button'
        value='Buscar'
        disabled={Object.values(selected).length === 0 && text === '' && tags === ''}
        onClick={fetchQuestions}
      />
      <input
        className={styles.button}
        type='button'
        value='Limpar'
        onClick={clearFiltersSelected}
      />
    </div>
  </>
)

QuestionFilters.propTypes = {
  text: PropTypes.string,
  tags: PropTypes.string,
  filters: PropTypes.array.isRequired,
  handleFiltersChange: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  fetchQuestions: PropTypes.func.isRequired,
  clearFiltersSelected: PropTypes.func.isRequired,
  selected: PropTypes.object.isRequired,
}

export default QuestionFilters
